import { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import { Table, Input } from 'reactstrap';
import { VpSelect } from '../../components/ui/VpSelect';
import { useListTenants } from '../../api/platformTenants';
import { StatusBadge } from '../../components/StatusBadge';
import { EmptyState } from '../../components/EmptyState';
import { PageHeading } from '../../layouts/PageHeading';
import { useFilterSidebar } from '../../layouts/FilterSidebarContext';
import { PageFilters, FilterSection } from '../../components/ui/PageFilters';

export default function TenantsList() {
  const auth = useAuth();
  const token = auth.user?.access_token ?? null;
  const [search, setSearch] = useState('');
  const [status, setStatus] = useState<'all' | 'active' | 'suspended'>('all');
  const { data, isLoading } = useListTenants(token, { search: search || undefined, status });

  // SP-8a — sidebar filtri.
  const sidebar = useMemo(() => (
    <PageFilters>
      <FilterSection title="Cerca">
        <Input
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="code o nome"
        />
      </FilterSection>
      <FilterSection title="Status">
        <VpSelect
          ariaLabel="Status"
          options={[
            { value: 'all', label: 'tutti' },
            { value: 'active', label: 'attivo' },
            { value: 'suspended', label: 'sospeso' },
          ]}
          value={status}
          onChange={(v) => setStatus((v ?? 'all') as 'all' | 'active' | 'suspended')}
        />
      </FilterSection>
    </PageFilters>
  ), [search, status]);
  useFilterSidebar(sidebar);

  return (
    <div>
      <PageHeading scope="Tenants" meta="Multi-tenant management — platform-admin" />

      <div className="d-flex mb-3">
        <Link to="/admin/tenants/new" className="btn btn-primary ms-auto">
          <i className="bi bi-plus-lg me-1" />+ Nuovo tenant
        </Link>
      </div>

      {isLoading ? (
        <p className="text-muted">Caricamento…</p>
      ) : data?.data.length === 0 ? (
        <EmptyState
          title="Nessun tenant ancora"
          body="Crea il primo tenant per iniziare."
          cta={{ label: '+ Nuovo tenant', onClick: () => { window.location.href = '/admin/tenants/new'; } }}
        />
      ) : (
        <div className="table-responsive">
        <Table className="table-hover align-middle table-striped mb-0">
          <thead>
            <tr>
              <th>Code</th><th>Name</th><th>Status</th><th />
            </tr>
          </thead>
          <tbody>
            {data?.data.map((t) => (
              <tr key={t.id} style={{ opacity: t.status === 'suspended' ? 0.85 : 1 }}>
                <td className="font-monospace vp-code">{t.code}</td>
                <td>{t.name}</td>
                <td>
                  <StatusBadge tone={t.status === 'active' ? 'success' : 'warn'}>
                    {t.status === 'active' ? 'attivo' : 'sospeso'}
                  </StatusBadge>
                </td>
                <td><Link to={`/admin/tenants/${t.id}?tab=overview`}>→ Apri</Link></td>
              </tr>
            ))}
          </tbody>
        </Table>
        </div>
      )}
    </div>
  );
}
